<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Work Group Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <work-group-card v-if="work_group" :work_group="work_group" />
    <b-form @submit.prevent="onSubmit">
      <b-card no-body class="mt-4">
        <b-card-header>
          <span class="text-muted text-uppercase">Work Group Info</span>
        </b-card-header>
        <b-card-body>
          <b-form-group label="Identifier" :label-cols="2">
            <b-form-input
              type="text"
              v-model.trim="form_data.name"
              placeholder="Work Group Name"
            />
          </b-form-group>
          <b-form-group label="Description" :label-cols="2">
            <b-form-textarea
              v-model.trim="form_data.description"
              placeholder="Work Group Description"
            />
          </b-form-group>
        </b-card-body>
      </b-card>
      <custom-checkbox-list-form
        :collection="staff_collection"
        :selected="form_data.staffs"
        :name_fields="['first_name', 'last_name']"
        :custom_per_page="20"
        card_header="Work Group Staff(s)"
        form_data_field="staffs"
        search_placeholder="Staff search..."
        @updateFormData="updateFormData"
      />
      <custom-checkbox-list-form
        :collection="permission_collection"
        :selected="form_data.permissions"
        :name_fields="['name']"
        :page_options="[20, 40, 60]"
        :custom_per_page="40"
        card_header="Work Group Permissions(s)"
        form_data_field="permissions"
        search_placeholder="Permission search..."
        @updateFormData="updateFormData"
      />
    </b-form>
    <b-button
      class="my-4 float-right py-3 px-5"
      variant="success"
      @click="submitForm"
    >
      <i class="fal fa-save" /> Save
    </b-button>
  </div>
</template>

<script>
import CustomCheckboxListForm from "@/components/shared/form/CustomCheckboxListForm";
import WorkGroupCard from "./WorkGroupCard";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const StaffRepository = LabRepositoryFactory.get("staff");
const WorkGroupRepository = LabRepositoryFactory.get("workGroup");

export default {
  name: "WorkGroupForm",
  components: {
    CustomCheckboxListForm,
    WorkGroupCard,
  },
  props: {
    work_group: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      staff_collection: null,
      permission_collection: null,
      form_data: {
        name: null,
        description: null,
        staffs: [],
        permissions: [],
      },
    };
  },
  methods: {
    updateFormData(field, value) {
      this.form_data[field] = value;
    },
    submitForm() {
      return this.$emit("submit", this.form_data);
    },
    async init() {
      this.loading = true;

      const response = await StaffRepository.getAll();
      const { data } = await WorkGroupRepository.getPermissions();

      this.staff_collection = response.data.data;
      this.permission_collection = data.data;
      this.loading = false;
    }
  },
  created() {
    this.init();

    if (this.work_group) {
      const { name, description, role, staffs } = this.work_group;

      this.form_data = {
        name,
        description,
        permissions: role.permissions.map(({ id }) => id),
        staffs: staffs.map(({ id }) => id),
      };
    }
  },
};
</script>
